import React from 'react';
import './Loading.scss'; // Assumindo que você estará usando SCSS para estilos

const Loading = () => (
  <div className="loading">
    <div className="loading-circle"></div>
  </div>
);

export default Loading;
